import React from "react";
import { styled } from "@mui/material/styles";
import IcRevert from "../../../../../../../../../../../../Assets/Images/ImageEditorRevert.svg";
import { useImageEditorContext } from "../../../../../../../../context/ImageEditorProvider";
import UndoEnabled from "../../../../../../../../../../../../Assets/Icons/undoEnabled.svg";
import Undo from "../../../../../../../../../../../../Assets/Icons/undo.svg";
import IcCropClose from "../../../../../../../../../../../../Assets/Images/ImageEditorCropClose.svg";
import IcCropConfirm from "../../../../../../../../../../../../Assets/Images/ImageEditorCropConfirm.svg";
import { useADSContext } from "../../../../../../../../context/ADSProvider";

const Wrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 550,
});

const WrapperInner = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 10,
});

const CustomButton = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  backgroundColor: "#FB4764",
  borderRadius: 4,
  width: 50,
  height: 26,
  fontSize: 12,
  fontWeight: 600,
  color: "#ffffff",
});

const ImageEditorActions = () => {
  const {
    handleRevert,
    handleUndoEditImage,
    handleRedoEditImage,
    HasUndo,
    HasRedo,
    setIsEditingImage,
    setShowUnsavedChangesModal,
    IsCropping,
    discardCurrentSelection,
    cropCurrentSelection,
    saveImage,
  } = useImageEditorContext();

  const { handleProductCreationSuccess, setGlobalLoading } = useADSContext();

  const handleCancel = () => {
    if (HasUndo) {
      setShowUnsavedChangesModal(true);
    } else {
      setIsEditingImage(false);
    }
  };

  const handleSave = async () => {
    try {
      setGlobalLoading(true);
      const data = await saveImage();
      await handleProductCreationSuccess({
        productId: data,
        withStatusCheck: false,
      });
      setIsEditingImage(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  return (
    <Wrapper
      style={{ justifyContent: IsCropping ? "space-between" : "center" }}
    >
      {IsCropping && (
        <img
          src={IcCropClose}
          style={{ cursor: "pointer" }}
          alt="close"
          onClick={discardCurrentSelection}
        />
      )}

      <WrapperInner>
        <CustomButton onClick={handleCancel}>Cancel</CustomButton>
        <CustomButton onClick={handleSave}>Save</CustomButton>
        <img
          alt="revert"
          src={IcRevert}
          onClick={handleRevert}
          style={{ cursor: "pointer", width: 30 }}
        />

        <img
          alt="Undo"
          style={{ cursor: "pointer" }}
          src={HasUndo ? UndoEnabled : Undo}
          onClick={handleUndoEditImage}
        />

        <img
          alt="redo"
          style={{ transform: "scale(-1, 1)", cursor: "pointer" }}
          src={HasRedo ? UndoEnabled : Undo}
          onClick={handleRedoEditImage}
        />
      </WrapperInner>

      {IsCropping && (
        <img
          src={IcCropConfirm}
          style={{ cursor: "pointer" }}
          alt="close"
          onClick={cropCurrentSelection}
        />
      )}
    </Wrapper>
  );
};

export default ImageEditorActions;
